<template lang="pug">
  nav.sidebar
    ul
      li(v-for="(item, index) in transmitters" :key="index")
        div.menu-item(@click="toggle(index)")
          .transmitter
            span.name {{ item.name }}
            .right-group
              BatteryIcon(:battery="item.bat_voltage") 
              span.arrow(
                :class="[{ rotated: item.sensors_count > 0 && openIndexes.includes(index) },{ disabled: item.sensors_count <= 0 }]"
                @click="item.sensors_count > 0 && toggleItem(index)"
              )

        ul.submenu(v-if="openIndexes.includes(index) && item.sensors_count > 0")
          li(
            v-for="(child, cIndex) in item.soil_sensors"
            :key="cIndex"
            @click="handleSoilSensor(child)"
            :class="{ selected: soilSensor && soilSensor.id === child.id }"
          ) 
            | {{ (child.name ? child.name :  "-" ) + " (" + child.sensor_number + handleSensorType(child.sensor_type) + ")"  }}
</template>

<script>
import { filterUtils, inBetween } from "@utils/filterUtils";
import { routerUtils } from "@utils/router";
import { roles } from "@utils/roles";
import store from "@state/store";
import { mapActions, mapMutations, mapState } from "vuex";
import { general } from "@src/services/dynamicViews/general";
import { dynamicViewsConstants } from "@src/constants";
import BatteryIcon from '../../_shared/BatteryIcon.vue';

export default {
  name: "SoilSensorsList",
  mixins: [filterUtils, routerUtils, general],
  components: {
    BatteryIcon
  },

  props: {
    transmitters: {
      type: Array
    },

    selectedStatus: {
      type: String,
    }
  },

  computed: {
    ...mapState("auth", ["user"]),
    ...mapState("soilSensor", ["soilSensor"])
  },

  data() {
    return {
      openIndexes: [],

      inBetween,
      dynamicViewsConstants
    }
  },

  methods: {
    ...mapMutations("soilSensor", ["setSoilSensor"]),

    handleSoilSensor(sensor){
      this.setSoilSensor(sensor);
    },

    toggle(index) {
      if (this.openIndexes.includes(index)) {
        this.openIndexes = this.openIndexes.filter(i => i !== index);
      } else {
        this.openIndexes.push(index);
      }
    },

    handleSensorType(type){
      if(type)
        switch (type) {
          case '0e':
            return 'NPK';
          case 'ee':
            return 'THCNPK';
          case 'de':
            return 'THPHNPK';
          case '10':
            return 'PH';
          case 'c0':
            return 'TH';
          case 'e0':
            return 'THC';
          case 'f0':
            return 'THCPH';
          case 'd0':
            return 'THPH';
          case 'fe':
            return 'THCPHNPK';
          default:
            return 'THC';
        }
    },

  }
}
</script>

<style lang="scss" scoped>
.name {
  font-size: 14px;
  flex: 1;
}

.right-group {
  display: flex;
  align-items: center;
  gap: 8px; /* space between battery and arrow */
}

.transmitter {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%; /* or set a fixed width if needed */
}

.transmitter span {
  flex-shrink: 1;
  margin-right: 8px;
}

.transmitter BatteryIcon {
  flex-shrink: 0;
}

.arrow {
  position: relative;
  display: inline-block;
  width: 10px;
  height: 10px;
  margin-left: 8px;
  transform: rotate(0deg);
  transition: transform 0.3s ease;
}

.arrow::before,
.arrow::after {
  content: '';
  position: absolute;
  width: 6px;
  height: 2px;
  background-color: #333;
  border-radius: 1px;
  transition: transform 0.3s ease;
}

.arrow::before {
  top: 3px;
  left: 0;
  transform: rotate(45deg);
  transform-origin: left center;
}

.arrow::after {
  bottom: 3px;
  left: 0;
  transform: rotate(-45deg);
  transform-origin: left center;
}

.arrow.rotated {
  transform: rotate(-90deg);
}

nav.sidebar {
  width: 250px;
  padding: 1rem;
  font-family: Arial, sans-serif;
}

nav.sidebar ul {
  list-style: none; /* Removes dots */
  padding-left: 0;
  margin: 0;
}

.menu-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.6rem 1rem;
  cursor: pointer;
  background-color: #ebedf0;
  border-radius: 8px;
  margin-bottom: 0.5rem;
  transition: background-color 0.2s ease;
}

.menu-item:hover {
  background-color: #dee2e6;
}

// .arrow {
//   font-size: 1.2rem;
//   transform: rotate(90deg);
//   transition: transform 0.3s ease;
// }

.submenu {
  margin-top: 0.3rem;
  padding-left: 1rem;
}

.submenu li {
  padding: 0.4rem 0.8rem;
  background-color: #fff;
  margin-bottom: 0.3rem;
  border-radius: 6px;
  transition: background-color 0.2s;
}

.submenu li:hover {
  background-color: #f1f3f5;
}

.submenu li.selected {
  background-color: #666565;
  color: #faf9f9;
}
</style>
